// Simple module-level token store for WebSocket connections.
// Cookies handle HTTP requests automatically, but WebSocket connections
// need the token as a query parameter.
let _accessToken: string | null = null;

export function getAccessToken(): string | null {
  return _accessToken;
}

export function setAccessToken(token: string | null): void {
  _accessToken = token;
}
